import WebsiteModal from "modal/WebsiteModal";

export default class ProductCardModal extends WebsiteModal {
    constructor(clonedElement) {
        super();
        this.$clonedElement = $(clonedElement);
    }

    buildElement() {
        this.$modal = (
            eotwJSXFactory('div', {className: "modal modal--product-card"}, [
                eotwJSXFactory('div', {className: "modal__bg js-close-modal"}),
                eotwJSXFactory('div', {className: "modal__container modal__container--560"}, [
                    eotwJSXFactory('button', {className: "modal__close js-close-modal"}),
                    this.$clonedElement
                ])
            ])
        );
    }
}
